// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"705":"dc112a36","922":"c15bf2b0"}[chunkId] || chunkId) + "." + {"317":"01ded80b5aefb180","355":"650e728644288d16","393":"f392525fdd5f23a4","669":"4377004fda257b98","705":"1b819be7b82b54d8","922":"7afd5b8ecb54ba56"}[chunkId] + ".js";
};